import React, { useState, useEffect} from 'react';
import { Grid, Typography, Button, Box } from '@mui/material';
import backgroundImage from '../assets/img/background.jpg';
import useStyles from '../styles/styles';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { colors } from './Theme/WebTheme';
const Hero = (props) => {
  const classes = useStyles();
  const { t, i18n  } = useTranslation();
  const isRTL = i18n.dir();
  const navigate = useNavigate();
  const [loggedIn, setLoggedIn] = useState(false);
  const auth = useSelector(state => state.auth);

  const role = props.role;

  useEffect(()=>{
    if(auth.profile && auth.profile.uid){
      setLoggedIn(true);
    }else{
      setLoggedIn(false);
    }
  },[auth.profile]);

  return (
    <Box className={classes.heroBox} sx={{ backgroundImage: `url(${backgroundImage})`, backgroundPosition: '21% 0%',
    backgroundSize: 'cover', backgroundRepeat: 'no-repeat',  
  }} style={{direction:isRTL === 'rtl'? 'rtl':'ltr'}}>
      <Grid container spacing={15} className={classes.gridContainer}>
        <Grid item xs={12} md={7}>
          <Typography variant="h3" fontWeight={500} className={classes.titleMain}>
          {t('book_your_title')}
          </Typography>
          <Typography variant="h6" className={classes.subtitleMain}>
           {t('about_us_content2')}
          </Typography>
            <Button
              variant="contained"
              color="primary"
              sx={{width:'200px',fontSize: '16px',backgroundColor:colors.GREEN,}}
              onClick={(e) => { e.preventDefault();
                if(loggedIn){
                 navigate((role && role === 'driver') ? '/bookings' : '/addbookings')
                }else{
                  navigate('/login')
                }
              }}
            >
            {role === 'driver' ? t('info') : t('book_your_ride_menu')}
            </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Hero;